import { Component, OnInit, HostListener } from '@angular/core';
import { ModalService } from '@avla/ui-design';
import { ModalTourComponent } from '@shared/component/modal-tour/modal-tour.component';

@Component({
  selector: 'app-menu-help',
  templateUrl: './menu-help.component.html',
  styleUrls: ['./menu-help.component.scss']
})
export class MenuHelpComponent implements OnInit {

  menuOpen = false;
  private modalTour: string = ModalTourComponent.modalName;
  
  @HostListener('document:click', ['$event'])
  documentClick(event: MouseEvent) {
    if (this.menuOpen) {
      this.menuOpen = false;
    }
  }

  constructor(private readonly modalService: ModalService) { }

  ngOnInit(): void {
  }

  toggleMenu() {
    if (!this.menuOpen) {
      setTimeout(() => {
        this.menuOpen = true;
      }, 10);
    }
  }
  openModalTour() {
    this.modalService.open(this.modalTour);
  }
}
